import React from 'react';

import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Alert, { AlertProps, Color } from '@material-ui/lab/Alert';
import units from '../theme/units';

export type Severity = Color | 'notification';

export type Props = Omit<AlertProps, 'severity'> & {
  severity?: Severity;
};

export type { Props as AlertProps };

const useNotificationStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.grey[700],
      backgroundColor: theme.palette.grey[50],

      [theme.breakpoints.down('sm')]: {
        border: units.border(1, 'solid', theme.palette.grey[200]),
      },
    },
    icon: {
      color: 'inherit !important',
    },
  }),
);

const ExtendedAlert: React.FC<Props> = ({ severity, ...props }) => {
  const alertProps = { ...props };

  const isNotification = React.useMemo(
    () => severity === 'notification',
    [severity],
  );
  const notificationStyles = useNotificationStyles();

  const classes = React.useMemo(
    () => (isNotification ? notificationStyles : {}),
    [isNotification, notificationStyles],
  );

  if (isNotification) {
    alertProps.icon = props.icon ? props.icon : false;
  }

  return (
    <Alert
      severity={isNotification ? undefined : (severity as Color)}
      classes={classes}
      {...alertProps}
    />
  );
};

export default React.memo(ExtendedAlert);
